import {
  addWeeklyHoliday,
  loadAllWeeklyHolidayPaginated,
} from "@/redux/rtk/features/hrm/holiday/weeklyHolidaySlice";
import { Button, Form, Input, Select, Typography, Row, Col } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

const { Title, Text } = Typography;
const days = [
  "Saturday",
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

const AddWeeklyHoliday = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    if (loader) return;
    setLoader(true);
    try {
      const resp = await dispatch(addWeeklyHoliday(values));
      if (resp?.payload?.message === "success") {
        form.resetFields();
        dispatch(
          loadAllWeeklyHolidayPaginated({
            page: 1,
            count: 10,
            status: "true",
          })
        );
      }
    } catch (err) {
      // optionally toast here
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className="text-center mb-6 px-2">
        <Title level={3} style={{ marginBottom: 4 }}>
          Add Weekly Holiday
        </Title>
        <Text type="secondary">Define your weekly off-day range.</Text>
      </div>

      <Form
        form={form}
        name="add-weekly-holiday"
        layout="vertical"
        className="px-2 sm:px-6"
        onFinish={onFinish}
        autoComplete="off"
        requiredMark={false}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={16} md={14}>
            <Form.Item
              style={{ marginBottom: 10 }}
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input name!",
                },
              ]}
            >
              <Input placeholder="Saturday–Friday" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={7}>
            <Form.Item
              style={{ marginBottom: 10 }}
              label="Start Day"
              name="startDay"
              rules={[
                {
                  required: true,
                  message: "Please select start day!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Select Start Day"
                className="w-full"
                disabled={loader}
              >
                {days.map((d) => (
                  <Select.Option key={d} value={d}>
                    {d}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={7}>
            <Form.Item
              style={{ marginBottom: 10 }}
              label="End Day"
              name="endDay"
              rules={[
                {
                  required: true,
                  message: "Please select end day!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Select End Day"
                className="w-full"
                disabled={loader}
              >
                {days.map((d) => (
                  <Select.Option key={d} value={d}>
                    {d}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Submit: full width on mobile, right-aligned on larger screens */}
        <div className="mt-2 flex justify-start">
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={loader}
            className="w-full sm:w-auto"
          >
            Add Weekly Holiday
          </Button>
        </div>
      </Form>
    </>
  );
};

export default AddWeeklyHoliday;
